//https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack
var context = require.context('../images/wyrmprints', false, /\.(png|jpe?g|svg)$/)

const keys = context.keys()
const images = context.keys().map(context)

export default function getImages(key) {
  let a = keys.indexOf('./'+ key + '_01.png')
  let b = keys.indexOf('./'+ key + '_02.png')
  return [images[a], images[b]]
}